import * as React from 'react';
import './Banner.css';
import { Link } from 'react-router-dom';
import logo from './logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface BannerDispatchProps {
    onToggle: (b: boolean) => void;
}

export interface BannerProps {
    expanded: boolean;
}

export const Banner: React.FC<BannerDispatchProps & BannerProps> = ({onToggle, expanded}) => (
    <div className="banner-wrapper">
        <div className="banner">
            <Link className="banner__logo" to="/">
                <img src={logo}/>
            </Link>
            <div className="banner__title">STOWARZYSZENIE METODY SOMAYOG, EDUKACJI I ROZWOJU</div>
            <div className="banner__bars" onClick={() => onToggle(!expanded)}>
                {expanded ? <FontAwesomeIcon icon={'times'}/> : <FontAwesomeIcon icon={'bars'}/>}
            </div>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/menu/Banner.tsx